import * as fromSites from '../reducers/sites';

export const getPage = (pageId) => (state) =>
    fromSites.getPage(pageId)(state.sites);

export const getHomePage = (siteId) => (state) =>
    fromSites.getHomePage(siteId)(state.sites);

export const getPagesBySiteId = (siteId) => (state) =>
    fromSites.getPagesBySiteId(siteId)(state.sites);

export const getIsLoading = (state) => fromSites.getIsLoading(state.sites);
export const getIsLoadingExport = (state) =>
    fromSites.getIsLoadingExport(state.sites);
